




























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { SurveyInfo } from '@/interfaces/SurveyInterfaces'
import { MainLogosTypes } from '@/interfaces/GeneralInterfaces'
import SurveyLocalStorageHelper from '@/utils/SurveyLocalStorageHelper'
import SurveyHelper from '@/utils/SurveyHelper'
import SurveyService from '@/services/SurveyService'

@Component({ name: 'DpChildSurveyWelcomePage' })
export default class DpChildSurveyWelcomePage extends Vue {
  @Prop({})
  surveyProduct!: string
  @Prop({})
  surveyUserId!: string

  @Getter('survey/getTakenSurveyId')
  takenSurveyProductId!: number
  @Getter('survey/getTakenSurveyType')
  takenSurveyProductType!: string
  @Getter('survey/getTakenSurveyUserId')
  takenSurveyUserId!: number
  @Getter('survey/getDpSurveyUserId')
  dpSurveyUserId!: number

  @Getter('survey/isTakenSurveyInitiated')
  isTakenSurveyInitiated!: boolean
  @Getter('survey/isDpTakenSurvey')
  isDpTakenSurvey!: boolean

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  isUncompletedSurvey: boolean = false

  async created () {
    if (!this.isTakenSurveyInitiated) {
      const redirect = await this.uploadDpSurveyData()

      if (redirect) {
        return
      }
    }

    if (!this.isDpTakenSurvey) {
      this.$router.push({ name: 'notFound' })
      return
    }

    this.isUncompletedSurvey = SurveyLocalStorageHelper.hasSurveyUser(this.surveyProduct, this.takenSurveyUserId)
  }

  async uploadDpSurveyData () : Promise<boolean> {
    let dpSurveyUserId: boolean | number = false
    if (SurveyLocalStorageHelper.hasSurveyUser(this.surveyProduct, parseInt(this.surveyUserId))) {
      dpSurveyUserId = await SurveyHelper.uploadDpSurveyDataByChild(
        SurveyLocalStorageHelper.getSurveyUser(this.surveyProduct, parseInt(this.surveyUserId))
      )
    } else {
      const parentDpSurveyUserId = SurveyLocalStorageHelper.getParentDpSurveyUserId(this.surveyProduct, parseInt(this.surveyUserId))
      if (parentDpSurveyUserId) {
        dpSurveyUserId = await SurveyHelper.uploadDpSurveyDataFromLocalStorage(parentDpSurveyUserId)
      }
    }

    if (typeof dpSurveyUserId === 'number') {
      const progress = await this.getDpProgress(dpSurveyUserId)
      return progress
    }
    return false
  }

  async getDpProgress (dpSurveyUserId: number) : Promise<boolean> {
    const progress = await SurveyService.getDpSurveyProgress(dpSurveyUserId)

    if (progress.isCompleted || !progress.nextSurveyPart) {
      SurveyHelper.completeSurvey(SurveyHelper.DP, null, dpSurveyUserId)
      this.$router.push({ name: 'survey.complete', params: { title: this.surveyInfo.title } })
      // todo::[m] Add logic for handling completed survey
      // todo::[m] I leave these comments there, because logic of the completed survey is not fully described at moment
      return true
    }

    const nextSurveyProductInfo = await SurveyService.getSurveyInfoById(
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.id
    )

    this.$store.commit('survey/setTakenSurveyData', {
      productSurveyId: progress.nextSurveyPart.id,
      productSurveyType: progress.nextSurveyPart.product,
      surveyInfo: nextSurveyProductInfo
    })

    this.$store.commit('mainLogo/setLogos', nextSurveyProductInfo.logos)
    this.$store.commit('mainLogo/setType', MainLogosTypes.SURVEY_LOGOS)

    this.$store.commit('survey/setTakenSurveyUserId', {
      productSurveyType: progress.nextSurveyPart.product,
      surveyUserId: progress.nextSurveyPart.surveyUserId
    })

    SurveyLocalStorageHelper.addDpChildSurveyUser(
      dpSurveyUserId,
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.surveyUserId
    )

    if (this.$route.params['surveyProduct'] !== progress.nextSurveyPart.product ||
      this.$route.params['surveyUserId'] !== progress.nextSurveyPart.surveyUserId.toString()
    ) {
      this.$router.push({
        name: 'survey.welcome.dp.survey_product',
        params: {
          surveyProduct: progress.nextSurveyPart.product,
          surveyUserId: progress.nextSurveyPart.surveyUserId.toString()
        }
      })
      return true
    }

    return false
  }

  async beginSurvey () {
    SurveyLocalStorageHelper.beginDpChildSurvey({
      surveyProductType: this.takenSurveyProductType,
      surveyAccessCode: null,
      surveyProductId: this.takenSurveyProductId,
      surveyProductTitle: this.surveyInfo.title,
      surveyUserId: this.takenSurveyUserId,
      dpSurveyId: this.dpSurveyUserId,
      dpChildSurveys: []
    })

    this.$router.push({
      name: 'survey.dp.page.part',
      params: {
        surveyProduct: this.surveyProduct,
        surveyUserId: this.takenSurveyUserId.toString(),
        sectionNumber: '1'
      }
    })
  }
}
